import { buildPaginationRequestParams } from '../../services/pagination';
import { memberListLayoutChange, setMembers } from '../members/actions';
import { getQuery } from './selectors';
import { MEMBERS_PER_PAGE, DEFAULT_FILTER, DEFAULT_SORT } from '../../constants/pagination';
import { rolesActionClicked, customRolesActionsMap, openRoleModal } from '../roles/actions';
import { MEMBERS_LIST_ORIGIN } from '../../constants/bi';

const uri = require('urijs');

export const SET_PAGE_LAYOUT = 'members/SET_PAGE_LAYOUT';
export const SET_IS_LOADING = 'members/SET_IS_LOADING';
export const CLEAR_MEMBERS = 'members/CLEAR_MEMBERS';
export const SET_METADATA = 'members/SET_METADATA';
export const SET_MEMBER_IDS = 'members/SET_MEMBER_IDS';
export const SET_MEMBERS_BADGE_ID_FILTER = 'members/SET_MEMBERS_BADGE_ID_FILTER';
export const MEMBERS_SORT = 'members/MEMBERS_SORT';
export const MEMBERS_FILTER = 'members/MEMBERS_FILTER';
export const MEMBERS_SEARCH = 'members/MEMBERS_SEARCH';
export const REMOVE_MEMBER_FROM_LIST = 'members/REMOVE_MEMBER_FROM_LIST';
export const LAST_MEMBER_FETCH_SOURCE = 'members/LAST_MEMBER_FETCH_SOURCE';

export const setMembersSort = (sort) => ({ type: MEMBERS_SORT, payload: sort });
export const setMembersSearch = (search) => ({
  type: MEMBERS_SEARCH,
  payload: search,
});
export const setMembersFilter = (filter) => ({
  type: MEMBERS_FILTER,
  payload: filter,
});
const setIsLoading = (isLoading) => ({
  type: SET_IS_LOADING,
  payload: isLoading,
});
const setMetadata = (metadata) => ({ type: SET_METADATA, payload: metadata });
export const setMembersBadgeIdFilter = (badgeId) => ({ type: SET_MEMBERS_BADGE_ID_FILTER, payload: badgeId });
export const clearMembers = () => ({ type: CLEAR_MEMBERS });
const setMemberIds = (memberIds) => ({
  type: SET_MEMBER_IDS,
  payload: memberIds,
});
const setMembersLayout = (view) => ({
  type: SET_PAGE_LAYOUT,
  payload: view,
});
export const removeMemberFromList = (uid) => ({
  type: REMOVE_MEMBER_FROM_LIST,
  payload: uid,
});
const setLastMemberFetchSource = (fetchSource) => ({
  type: LAST_MEMBER_FETCH_SOURCE,
  payload: fetchSource,
});

export const fetchMembers = (page = 1) => (dispatch, getState, { request }) => {
  const url = uri('_api/members').query({
    ...getQuery(getState()),
    ...buildPaginationRequestParams(page, MEMBERS_PER_PAGE),
  });

  const source = request.getCancelToken();
  dispatch(setLastMemberFetchSource(source));

  dispatch(setIsLoading(true));
  return request(url, { cancelToken: source.token })
    .then((body) => ({
      members: body.items,
      memberIds: body.items.map((m) => m.uid),
      count: body.count,
      tooManyToCount: body.tooManyToCount,
    }))
    .then(({ members, memberIds, count, tooManyToCount }) =>
      Promise.all([
        dispatch(setMembers(members)),
        dispatch(setMemberIds(memberIds)),
        dispatch(setMetadata({ page, count, tooManyToCount })),
      ]),
    )
    .then(() => dispatch(setIsLoading(false)))
    .catch((e) => {
      dispatch(setIsLoading(false));
      throw e;
    });
};

export const clearMembersBadgeIdAndFetch = () => (dispatch) => {
  dispatch(setMembersBadgeIdFilter(null));
  dispatch(clearMembers());
  dispatch(fetchMembers());
};

export const setMembersSortAndFetch = (sort) => (dispatch) => {
  dispatch(setMembersBadgeIdFilter(null));
  dispatch(setMembersFilter(DEFAULT_FILTER));
  dispatch(setMembersSearch(''));
  dispatch(setMembersSort(sort));
  dispatch(clearMembers());
  dispatch(fetchMembers());
};

export const setMembersFilterAndFetch = (filter) => (dispatch) => {
  dispatch(setMembersBadgeIdFilter(null));
  dispatch(setMembersSort(DEFAULT_SORT));
  dispatch(setMembersSearch(''));
  dispatch(setMembersFilter(filter));
  dispatch(clearMembers());
  dispatch(fetchMembers());
};

export const setMembersSearchAndFetch = (search = null) => (dispatch, getState) => {
  // Member search is only possible in the default mode
  dispatch(setMembersSort(DEFAULT_SORT));
  dispatch(setMembersFilter(DEFAULT_FILTER));
  dispatch(setMembersSearch(search));
  dispatch(clearMembers());
  const lastMemberFetchSource = getState().membersPage.lastMemberFetchSource;
  if (lastMemberFetchSource) {
    lastMemberFetchSource.cancel();
    dispatch(setLastMemberFetchSource(null));
  }
  dispatch(fetchMembers());
};

const onDeleteMember = (memberId) => (dispatch) => {
  dispatch(removeMemberFromList(memberId));
};

export const onRoleAction = (memberId, role) => (dispatch) => {
  dispatch(rolesActionClicked(memberId, role.roleId, MEMBERS_LIST_ORIGIN));

  if (customRolesActionsMap[role.roleId]) {
    return dispatch(customRolesActionsMap[role.roleId]({ memberId, onDeleteMember }));
  }

  return dispatch(openRoleModal(memberId, role));
};

export const onSetMembersLayout = (layoutType) => (dispatch) => {
  dispatch(setMembersLayout(layoutType));
  dispatch(memberListLayoutChange(layoutType));
};
